module.exports = __webpack_public_path__ + "static/img/field_medical.3da4b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/field_medical.png
// module id = irkI
// module chunks = 1